/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    cancelButton: "Annuler",
    confirmButton: "Valider",
    inputText: {
        placeholder: "ex. Visitez mon site"
    },
    inputTextLabel: "Text affiché (optionnel)",
    linkModalLabel: "Insérer un lien"
};